/**
 * Client configuration.
 *
 * Everything here is compiled into the bundle and therefore public. No secret
 * may ever be referenced in this file — the Google client *secret*, for example,
 * lives only in the Worker.
 */

const rawApiBaseUrl = import.meta.env['VITE_API_BASE_URL'];

export const config = {
  /**
   * Empty string means same-origin: in development Vite proxies /api to the
   * Worker, and in production Pages and the Worker share a hostname through the
   * same fetch path. Cookie behaviour is then identical in both, which is what
   * stops "works locally, fails deployed" auth bugs.
   */
  apiBaseUrl: typeof rawApiBaseUrl === 'string' ? rawApiBaseUrl : '',
  appName: 'TaskFlow',
  organisation: 'Cuddles Foundation',
  isDevelopment: import.meta.env.DEV,
} as const;
